import { Injectable } from "@angular/core";
import { LIST_DEFINITIONS } from "../list-definition";
import { AccessGroupListProvider } from "./list-providers/access-group-list-provider";
import { IListProvider } from "./list-providers/list-provider.interface";
import { UserListProvider } from "./list-providers/user-list-provider";
import { MembershipListProvider } from "./list-providers/membership-list-provider";
import { LookupListProvider } from "./list-providers/lookup-list-provider";
import { JobStatusListProvider } from "./list-providers/job-status-list-provider";
import { JobTypeListProvider } from "./list-providers/job-type-list-provider";
import { ContactTypeListProvider } from "./list-providers/contact-type-list-provider";
import { LookupTypeListProvider } from "./list-providers/lookup-type-list-provider";
import { ContactListProvider } from "./list-providers/contact-list-provider";
import { ContactListAllProvider } from "./list-providers/contact-list-all-provider";
import { VasAppFacade } from "../../../services/vas-app-facade.service";
import { DummyListProvider } from "./list-providers/dummy-list-provider";

@Injectable()
export class ListPickerProviderService {

    constructor(protected appFacade: VasAppFacade) {

    }

    getProvider(type: string): IListProvider {

        switch (type) {
            case LIST_DEFINITIONS.ACCESS_GROUP: {
                return new AccessGroupListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.CONTACT: {
                return new ContactListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.CONTACT_ALL: {
                return new ContactListAllProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.CONTACT_TYPE: {
                return new ContactTypeListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.JOB_STATUS: {
                return new JobStatusListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.JOB_TYPE: {
                return new JobTypeListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.LOOKUP: {
                return new LookupListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.LOOKUP_TYPE: {
                return new LookupTypeListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.MEMBERSHIP: {
                return new MembershipListProvider(this.appFacade);
            }
            case LIST_DEFINITIONS.USER: {
                return new UserListProvider(this.appFacade);
            }
            default: {
                console.warn(`invalid list provider '${type}', not found. using dummy provider`);
                return new DummyListProvider(this.appFacade);

            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-picker-provider.service.ts